import React from 'react'

import { FormattedMessage, useIntl } from 'react-intl'
import { useSelector } from 'react-redux'

import { PCRChannels } from '@enums'
import { IApplicationState } from '@store'
import { selectActivePCRChannel } from '@store/router'
import Theme from '@theme'
import { Container, H5 } from '@tribegroup'

export interface IInternalProps {
  activeChannel: PCRChannels
}

const PostCampaignReportSubmissionListEmpty: React.FC<IInternalProps> = ({ activeChannel }) => {
  const intl = useIntl()
  return (
    <Container topOuterSpacing={5}>
      <H5 center color={Theme.grey700Color}>
        <FormattedMessage
          id="postCampaignReport.submission.list.empty"
          values={{
            channel: intl.formatMessage({
              id: `postCampaignReport.text.${activeChannel}`,
            }),
          }}
        />
      </H5>
    </Container>
  )
}

const PostCampaignReportSubmissionListEmptyConnected: React.FC = () => {
  const activeChannel = useSelector((state: IApplicationState) => selectActivePCRChannel(state))
  return <PostCampaignReportSubmissionListEmpty activeChannel={activeChannel} />
}

export { PostCampaignReportSubmissionListEmpty }
export default PostCampaignReportSubmissionListEmptyConnected
